import { useCallback } from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import useNavigation from '@/hooks/useNavigation';

interface UseOpenCoachDrawerProps {
  syncInQueryParam?: boolean;
}

const COACH = 'coach';

export default function useOpenCoachDrawer(props: UseOpenCoachDrawerProps) {
  const { syncInQueryParam = false } = props;
  const [showKnowledgeBaseCopilot, { on, off }] = useToggle(false);

  const navigation = useNavigation();
  const isCoachOpenFromQueryParam = navigation.query[COACH] === 'true';

  const onClick = useCallback(() => {
    on();
    if (syncInQueryParam) {
      navigation.push('', { query: { [COACH]: true }, appendQuery: true });
    }
  }, [on, syncInQueryParam, navigation]);

  const onClose = useCallback(() => {
    off();
    if (syncInQueryParam) {
      const url = new URL(navigation.asPath, window.location.origin);
      url.searchParams.delete(COACH);
      navigation.back(`${url.pathname}${url.search}`);
    }
  }, [off, syncInQueryParam, navigation]);

  const isOpen = syncInQueryParam ? isCoachOpenFromQueryParam : showKnowledgeBaseCopilot;

  return {
    isCoachOpen: isOpen,
    openCoach: onClick,
    closeCoach: onClose,
  };
}
